import { useState, useEffect } from "react";
import './style.css';
import axios from "axios";
import MailIcon from "../../assets/svgIcon/MailIcon";
import LinkedinIcon from "../../assets/svgIcon/LinkedinIcon";
import GithubIcon from "../../assets/svgIcon/GithubIcon";

export default function ContactSection(){

    const [data, setData] = useState({
        Name: '',
        Email: '',
        Message: ''
    });
    const [response, setResponse] = useState({
        Type:"",
        Message:""
    });
    const [isLoading,setIsLoading] = useState(false);

    const onChange = e =>{
        setData({...data,[e.target.name]:e.target.value});
    }

    // on submit form
    function onPost() {
        var name_regex = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;
        var email_regex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        var message_regex = /^.{20,200}$/;

        if(!name_regex.test(data.Name)){
            setResponse({
                Type:"error",
                Message:"Enter valid name!"
            });
        }else{
            setResponse({
                Type:"",
                Message:""
            });
            if(!email_regex.test(data.Email)){
                setResponse({
                    Type:"error",
                    Message:"Enter valid email address!"
                });
            }else{
                setResponse({
                    Type:"",
                    Message:""
                });
                if(!message_regex.test(data.Message)){
                    setResponse({
                        Type:"error",
                        Message:"Enter valid message (more than 20 chat.)!"
                    });
                }else{
                    setResponse({
                        Type:"",
                        Message:""
                    });
                    login();
                }
            }
        }
    }
    const login = async (e) => {
        try {
            setIsLoading(true);
            await axios.get('https://script.google.com/macros/s/AKfycbyluuyt0cMgWTmkEAigOJ7LU4QVwEkeME0QtI5uett9Lf_e9TkDs8VtkHCDLuqGuBes1w/exec?Name='+data.Name+'&Email='+data.Email+'&Message='+data.Message)
            .then(response=>{
                setResponse('');
                if(response.data.result === 'success'){
                    setResponse({
                        Type:"success",
                        Message:"Thanks for message, we will get back to you as soon."
                    });
                    setData({
                        Name:'',
                        Email: '',
                        Message: ''
                    });
                }else{
                    setResponse({
                        Type:"error",
                        Message:"Something went wrong!"
                    });
                }
            })
            .catch(error =>{
                setResponse({
                    Type:"error",
                    Message:"Something went wrong!"
                });
            });
            setIsLoading(false);
        } catch (error) {
            setResponse({
                Type:"error",
                Message:"Something went wrong!"
            });
            setIsLoading(false);
        }
    }
    useEffect(() => {
        if (response.Message || response.Type) {
            const timer = setTimeout(() => {
                setResponse({ Type: "", Message: "" });
            }, 10000); // 10000ms = 10s
    
            return () => clearTimeout(timer); // Clean up on re-render
        }
    }, [response]);

    return(
        <section id="Contact">
            <div className="page center">
                <div className="sub-section">
                    <div className="header-div">
                        <h1 className="title">Let's Build Something Together 💻</h1>
                    </div>
                    <p className="description">
                    Have an idea or want to collaborate? Send me a message—I'd love to connect!
                    </p>
                    <form>
                        <div className="inputBox">
                            <p className={"message "+response.Type}>{response.Message}</p>
                        </div>
                        <div className="inputBox">
                            <input type="text"
                            onChange={(e)=>{onChange(e)}} 
                            value={data.Name} name="Name" 
                            placeholder="Name" 
                            readOnly={isLoading} />
                        </div>
                        <div className="inputBox">
                            <input type="text"
                            onChange={(e)=>{onChange(e)}} 
                            value={data.Email} name="Email" 
                            placeholder="Email" 
                            readOnly={isLoading} />
                        </div>
                        <div className="inputBox">
                            <textarea type="text"
                            onChange={(e)=>{onChange(e)}} 
                            value={data.Message} name="Message" 
                            placeholder="Message" 
                            readOnly={isLoading} />
                        </div>
                        <div className="inputBox">
                            <button type="button" disabled={isLoading} onClick={()=>{onPost()}}>{!isLoading ? ("Send"):("Sending...")}</button>
                        </div>
                    </form>
                </div>
                <div className="sub-section">
                    <div className="header-div">
                        <p className="title msg">Thank you</p>
                        <div className="social">
                            <a href="mailto:uttamnath1764@gmail.com"><MailIcon/></a>
                            <a href="https://github.com/Uttamnath64"><GithubIcon/></a>
                            <a href="https://www.linkedin.com/in/uttamnath64/"><LinkedinIcon/></a>
                        </div>
                        <p className="lable-2 msg">Version: v3.0.0</p>
                        <p className="lable msg">@2026 UttamNath</p>
                    </div>
                </div>
            </div>
        </section>
    );
}